const CareerHeroSection = () => {
  return (
    <div className="relative mt-5 w-full overflow-hidden bg-white">
      {/* Background Map Image */}
      {/* <img 
        src="/img/about-us/map-japan-2.png" 
        alt="Japan Map Background" 
        className="absolute inset-0 w-full h-full object-cover opacity-10"
      /> */}

      {/* Main Content */}
      <div className="relative z-10 flex flex-col items-center justify-between py-16 pl-4 lg:flex-row lg:py-24 lg:pl-12">
        {/* Left Content */}
        <div className="mb-12 max-w-2xl flex-1 lg:mb-0">
          <h1 className="mb-8 text-4xl font-bold leading-tight lg:text-6xl">
            <span className="text-gray-800">Bergabunglah Bersama</span>
            <br />
            <span className="text-red-600">YES Academy</span>
          </h1>

          <div className="space-y-4 text-lg leading-relaxed text-gray-600 lg:text-xl">
            <p>
              <span>
                Jadilah bagian dari Pengembangan Tenaga Kerja Unggul Indonesia
                bersama{' '}
              </span>
              <span className="font-semibold text-red-600">YES Academy!</span>
            </p>

            <p>
              Kami berkomitmen untuk membangun lingkungan kerja yang kolaboratif
              dan suportif, di mana tim kami dapat tumbuh dan berkembang secara
              optimal.
            </p>
          </div>
        </div>

        {/* Right Content - Hero Image */}
        <div className="max-w-2xl flex-1">
          <img
            src="/img/career/Frame-1000003114.png"
            alt="YES Academy Team"
            className="h-auto w-full object-contain"
          />
        </div>
      </div>
    </div>
  )
}

export default CareerHeroSection
